// Utils
import { http } from '../utils/services/http';

/**
 * Hits the `/api/ping` route to determine if the app can connect to the API.
 *
 * At the time of writing this is used when the native app is put to sleep or resumed so the reconnecting
 * state is shown correctly to the user.
 */
export const checkAppServerConnection = async () => {
    try {
        const response = await http({ url: 'ping' });
        return !!response?.data?.success;
    } catch (e) {
        return false;
    }
};
